module.exports = __webpack_public_path__ + "static/media/down-arrow.8ffc22ba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/citylink/down-arrow.svg
// module id = 674
// module chunks = 0